import { Component, OnInit } from '@angular/core';

import { distinctUntilChanged, map } from 'rxjs/operators';

import AlphaLevelFacade from '@app/core/facades/alpha-level.facade';
import { FilterType } from '@app/shared/components/sub-header/filter-type.model';
import FilterChange from '@app/shared/filters/filter-change.model';
import FilterComponent from '@app/shared/filters/filter.component';

const SIZE = '127px';

@Component({
  selector: 'app-filter-level',
  templateUrl: '../filter.component.html',
  styleUrls: ['../filter.component.scss'],
})
export default class LevelComponent extends FilterComponent implements OnInit {
  public readonly label = 'Level';
  public readonly width = SIZE;

  constructor(private readonly _data: AlphaLevelFacade) {
    super();
  }

  public update(value: string, _: boolean): void {
    this._data.updateLevel(value);
    this.valueChange.emit(new FilterChange(FilterType.Level, value));
  }

  ngOnInit() {
    this.options$ = (!!this.config.transform ? this.config.transform(this._data.level$) : this._data.levels$).pipe(
      distinctUntilChanged(),
      map((options: Array<{ [key: string]: string }>) =>
        options?.map((option) => ({ label: `L${option.level}`, value: option.level }))
      )
    );

    this.initDefaultValues(this._data.level$);
  }
}
